import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import DeleteIcon from '@material-ui/icons/Delete'
import Box from '@material-ui/core/Box'
import { TableContainer } from '@material-ui/core'
import ViewAllDialog from './ViewAllDialog'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import DeleteDialog from './DeleteDialog'
import { biTubeConfigContext } from '../../../../Configurators/products/BiTube/BiTube'
import ErrorIcon from '@material-ui/icons/Error'
import { BiTubeProduct, BitubeProperties } from '../enum'
import { useFastduplexRuleValidationMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { ConfiguratorValues } from '../../../utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
  listContainer: {
    margin: theme.spacing(4, 0),
  },
  view: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  viewAll: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    padding: theme.spacing(0, 1, 0, 0),
    justifyContent: 'flex-end',
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
    fontWeight: theme.typography.fontWeightMedium,
  },
  viewAllScroll: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    padding: theme.spacing(0, 0, 0, 2),
    justifyContent: 'flex-end',
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
    fontWeight: theme.typography.fontWeightMedium,
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[500],
    fontWeight: theme.typography.fontWeightMedium,
  },
  button: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
    fontWeight: theme.typography.fontWeightMedium,
  },
  buttonTextIe: {
    padding: theme.spacing(0, 4, 0, 0),
  },
  viewAllScrollIE: {
    padding: theme.spacing(0, 2.5, 0, 0),
  },
  delete: {
    padding: theme.spacing(0),
    float: 'right',
  },
  divider: {
    margin: theme.spacing(1),
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    fontWeight: theme.typography.fontWeightMedium,
    '& $activeLabel': {
      color: theme.palette.primary.main,
    },
    wordBreak: 'break-all',
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightRegular,
  },
  listIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  errorIcon: {
    fontSize: theme.typography.pxToRem(18),
    verticalAlign: 'top',
    color: theme.palette.rich.red,
  },
  tableContainer: {
    maxHeight: 216,
  },
  deleteIcon: {
    fontSize: theme.typography.pxToRem(22),
    color: theme.palette.grey[400],
  },
  activeLabel: {},
}))
export interface OligoItem {
  label: string
  sequence: string
  bases: number
  scale: string
  id: number
  purification: string
  activeLink?: boolean
}

export interface ProductProps {
  setActive: React.Dispatch<React.SetStateAction<any>>
  productType: string
}

const ProductsSummary = (props) => {
  const classes = useStyles()
  const { productDetails, setActive } = props
  const [dialogOpen, setDialogOpen] = useState(false)
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [scrollBar, setScrollBar] = useState(false)
  const [delItem, setDelItem] = useState()
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const [fastduplexRuleValidation] = useFastduplexRuleValidationMutation()
  const [deleteItem, setDeleteItem] = useState(false)
  const [oligoChange, setOligoChange] = useState(false)
  const intl = useIntl()
  const maxItems = BitubeProperties.MaximumOligosAllowed
  const {
    sessionData,
    isValidTotalValidation,
    OligoIndex,
    countryCode,
    isComingFromConfimPage,
  } = bitubeState

  const delType = 'Selected'

  const [isIE, setIsIE] = useState(false)
  React.useEffect(() => {
    const ua = window.navigator.userAgent
    if (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1) {
      setIsIE(true)
    }
  }, [])

  const ruleValidation = async (obj) => {
    const response = await fastduplexRuleValidation({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.fastduplexRuleValidation.serverError) {
      if (!data.fastduplexRuleValidation.listErrors?.length) {
        sessionData[bitubeState.currentOligoIndex].listError = []
      }
      biTubeDispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: data.fastduplexRuleValidation,
      })
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }
  const GenerateId = () => {
    let newId = 0
    sessionData.forEach((data) => {
      if (Number(data.id) > newId) {
        newId = Number(data.id)
      }
    })
    return newId
  }
  const setInitialState = () => {
    if (sessionData.length !== 0 && sessionData[0].applyToAll) {
      return {
        isOverridden: false,
        name: '',
        sequence: '',
        fiveMod: '',
        purification: sessionData[0].purification,
        baseCount: 0,
        format: sessionData[0].format,
        concentration: sessionData[0].concentration,
        tubes: '1',
        price: '',
        scale: sessionData[0].scale,
        orderItemId: '',
        id: (GenerateId() + 1).toString(),
        comments: '',
        additionalComments: '',
        oligoId: GenerateId() + 1,
        countryCode: '',
        autoValidation: 'false',
        productType: productDetails.productType,
        customerOverhang: '',
        antisenceName: '',
        antisenceSequence: '',
        autoGenerateOligo: false,
        customerAntisenseOverHang: '',
        antisenceBaseCount: 0,
        amount: sessionData[0].amount,
        senseNameCheck: false,
        listError: [{ key: '', value: '' }],
      }
    }
    return {
      isOverridden: false,
      name: '',
      sequence: '',
      fiveMod: '',
      purification: '',
      baseCount: 0,
      format: '',
      concentration: '',
      tubes: '1',
      price: '',
      scale: '',
      orderItemId: '',
      id: (GenerateId() + 1).toString(),
      comments: '',
      additionalComments: '',
      oligoId: GenerateId() + 1,
      countryCode: '',
      autoValidation: 'false',
      productType: productDetails.productType,
      customerOverhang: '',
      antisenceName: '',
      antisenceSequence: '',
      autoGenerateOligo: false,
      customerAntisenseOverHang: '',
      antisenceBaseCount: 0,
      amount: '',
      senseNameCheck: false,
      listError: [{ key: '', value: '' }],
    }
  }

  const addOligo = () => {
    if (sessionData.length < BitubeProperties.MaximumOligosAllowed) {
      //Please correct error(s) before adding a new item
      biTubeDispatch({
        type: 'ADD_NEW_DUPLEX',
        data: true,
      })
      biTubeDispatch({ type: 'IS_COMING_FROM_CONFIGM_PAGE', data: false })
      biTubeDispatch({ type: 'CALL_TOTAL_VALIDATION', data: true })
      biTubeDispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 1,
      })
      biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
      biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
      biTubeDispatch({
        type: 'VALIDATE_ON_CLICK',
        data: true,
      })
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems }),
      })
      window.scrollTo(0, 0)
    }
  }
  const setErrorData = (index) => {
    return {
      name: sessionData[index].name,
      sequence: sessionData[index].sequence,
      scale: '',
      purification: sessionData[index].purification,
      fiveMod: sessionData[index].fiveMod,
      threeMod: sessionData[index].threeMod,
      researcher: '',
      isOverridden: sessionData[index].isOverridden,
      format: sessionData[index].format,
      concentration: sessionData[index].concentration,
      tubes: sessionData[index].tubes,
      customerOverhang: sessionData[index].customerOverhang,
      antisenceName: sessionData[index].antisenceName,
      antisenceSequence: sessionData[index].antisenceSequence,
      customerAntisenseOverHang: sessionData[index].customerAntisenseOverHang,
      antisenceThreeMod: sessionData[index].antisenceThreeMod,
      antisenceFiveMod: sessionData[index].antisenceFiveMod,
      antisenceBaseCount: 0,
      amount: sessionData[index].amount,
      autoGenerateOligo: sessionData[index].autoGenerateOligo,
      senseNameCheck: sessionData[index].senseNameCheck,
    }
  }

  // call when i am deleting any bitube products
  const performTubeDelete = (item, type) => {
    if (type === 'Selected' || type === 'SelectedViewAll') {
      if (OligoIndex !== 0) {
        const newIndex = OligoIndex - 1
        const array = [...bitubeState.sessionData]
        const index = array.indexOf(item)
        if (index !== -1) {
          sessionData.splice(index, 1)
        }
        biTubeDispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: newIndex,
        })
        biTubeDispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: newIndex,
        })
        biTubeDispatch({
          type: 'CALL_SESSION_API',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_INPUT',
          data: [...bitubeState.sessionData],
        })
        biTubeDispatch({
          type: 'UPDATE_ERROR_DATA',
          data: setErrorData(newIndex),
        })
        biTubeDispatch({
          type: 'IS_DELETE_SELECTED',
          data: 1,
        })
      } else {
        bitubeState.oligoCount = 0
        biTubeDispatch({
          type: 'SET_CONTINUE_TO_NEXT_PAGE',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: 0,
        })
        biTubeDispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: 0,
        })
        biTubeDispatch({
          type: 'UPDATE_ERROR_DATA',
          data: {
            ...bitubeState.errorData,
            name: '',
            sequence: '',
            scale: '',
            purification: '',
            fiveMod: '',
            threeMod: '',
            researcher: '',
            format: '',
            concentration: '',
            isOverridden: false,
            tubes: '1',
            antisenceName: '',
            antisenceSequence: '',
            countryCode: countryCode,
          },
        })
        biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
        biTubeDispatch({
          type: 'CALL_SESSION_API',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_INPUT',
          data: [setInitialState()],
        })
        biTubeDispatch({
          type: 'DELETE_LAST_OLIGO',
          data: bitubeState.deleteLastOligo + 1,
        })
        biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: false })
        biTubeDispatch({ type: 'IS_DELETE_ALL', data: true })
        biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: true })
        setDialogOpen(false)
      }
      if (isComingFromConfimPage) {
        biTubeDispatch({
          type: 'SET_CONTINUE_TO_NEXT_PAGE',
          data: false,
        })
      }
      setDeleteItem(true)
    } else if (type === 'All') {
      sessionData[0].applyToAll = false
      bitubeState.oligoCount = 0
      biTubeDispatch({
        type: 'SET_CONTINUE_TO_NEXT_PAGE',
        data: true,
      })
      biTubeDispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: 0,
      })
      biTubeDispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: 0,
      })
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...bitubeState.errorData,
          name: '',
          sequence: '',
          scale: '',
          purification: '',
          fiveMod: '',
          threeMod: '',
          researcher: '',
          format: '',
          concentration: '',
          isOverridden: false,
          tubes: '1',
          countryCode: countryCode,
        },
      })
      biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
      biTubeDispatch({
        type: 'CALL_SESSION_API',
        data: true,
      })
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [setInitialState()],
      })
      biTubeDispatch({
        type: 'IS_PAGE_RELOAD',
        data: true,
      })
      biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: true })
      biTubeDispatch({
        type: 'DELETE_LAST_OLIGO',
        data: bitubeState.deleteLastOligo + 1,
      })
      biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: false })
      biTubeDispatch({ type: 'IS_DELETE_ALL', data: true })
    }
    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    setDelDialogOpen(false)
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
  }

  // This method is use to perform delete and delete all operations
  const deleteOligoItem = (item, type) => {
    performTubeDelete(item, type)
    if (bitubeState.noContinueToNextPage && !isComingFromConfimPage) {
      biTubeDispatch({
        type: 'SET_CONTINUE_TO_NEXT_PAGE',
        data: false,
      })
    }
    if (isComingFromConfimPage) {
      biTubeDispatch({ type: 'IS_COMING_FROM_CONFIGM_PAGE', data: false })
    }
  }

  const displaySessionData = (data, index) => {
    if (productDetails.productType === BiTubeProduct.mirna) {
      setOligoChange(true)
    }
    biTubeDispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: index,
    })

    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })

    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: setErrorData(index),
    })

    biTubeDispatch({
      type: 'ITEM_VALIDATION',
      data: true,
    })
    biTubeDispatch({
      type: 'IS_PAGE_RELOAD',
      data: true,
    })
  }

  const handleViewAll = () => {
    biTubeDispatch({
      type: 'ITEM_VALIDATION',
      data: true,
    })
    setDialogOpen(true)
  }

  React.useEffect(() => {
    if (deleteItem || oligoChange) {
      ruleValidation(bitubeState.errorData)
      setDeleteItem(false)
      setOligoChange(false)
    }
  }, [bitubeState.errorData])

  React.useEffect(() => {
    if (sessionData.length > 5) {
      setScrollBar(true)
    } else {
      setScrollBar(false)
    }
  }, [sessionData])

  React.useEffect(() => {
    if (isValidTotalValidation && bitubeState.addNewDuplex) {
      const newIndex = sessionData.length
      biTubeDispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: newIndex,
      })
      biTubeDispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: newIndex,
      })
      biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
      const emptyStateObj = Object.assign({}, setInitialState())
      bitubeState.sessionData.push(emptyStateObj)
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...bitubeState.errorData,
          name: '',
          sequence: '',
          scale: '',
          purification: '',
          fiveMod: '',
          threeMod: '',
          researcher: '',
          format: '',
          concentration: '',
          isOverridden: false,
          tubes: '1',
          amount: '',
          customerOverhang: '',
          antisenceName: '',
          antisenceSequence: '',
          customerAntisenseOverHang: '',
          antisenceBaseCount: 0,
          antisenceFiveMod: '',
          antisenceThreeMod: '',
          senseNameCheck: false,
        },
      })
      biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [...bitubeState.sessionData],
      })
      biTubeDispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 1,
      })
      biTubeDispatch({
        type: 'ADD_NEW_DUPLEX',
        data: false,
      })
      biTubeDispatch({
        type: 'DELETE_LAST_OLIGO',
        data: 0,
      })
      biTubeDispatch({
        type: 'SET_CONTINUE_TO_NEXT_PAGE',
        data: true,
      })
      biTubeDispatch({
        type: 'IS_PAGE_RELOAD',
        data: true,
      })
      ruleValidation({
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: '',
        concentration: '',
        isOverridden: false,
        tubes: '1',
        amount: '',
        customerOverhang: '',
        antisenceName: '',
        antisenceSequence: '',
        customerAntisenseOverHang: '',
        antisenceBaseCount: 0,
        antisenceFiveMod: '',
        antisenceThreeMod: '',
        senseNameCheck: false,
      })
    }
    window.scrollTo(0, 0)
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.oligoCount])

  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelItem(item)
  }

  const renderData = () => {
    const result: any[] = []

    const displayError = (indexNo) => {
      let errFlag = false
      let reviewErr = false
      if (sessionData[indexNo].listError) {
        sessionData[indexNo].listError.forEach((item) => {
          if (item.key) {
            if (
              item.key !== '' &&
              !item.value?.startsWith(BitubeProperties.RequiredField) &&
              item.key !== BitubeProperties.ReviewError
            ) {
              reviewErr = true
            } else if (
              item.key !== '' &&
              item.key !== BitubeProperties.ReviewError
            ) {
              errFlag = true
            }
          }
        })
      }
      if (bitubeState.errorIconOnPageload) {
        return ''
      }
      if (errFlag && bitubeState.pageError.length !== 0) {
        return <ErrorIcon className={classes.errorIcon} />
      } else if (reviewErr || errFlag) {
        return <ErrorIcon className={classes.errorIcon} />
      } else {
        return ''
      }
    }
    sessionData.map((item, index) =>
      result.push(
        <Grid
          container
          alignItems="flex-end"
          className={classes.listContainer}
          key={index}
        >
          <Grid item sm={1} className={classes.listIcon}>
            <img alt="hexes" src="/static/hexes.png" />
          </Grid>
          <Grid
            item
            sm={10}
            className={clsx(
              index === bitubeState.currentOligoIndex && classes.active
            )}
            //className={clsx(classes.active)}
          >
            <Link
              href="#"
              onClick={() => displaySessionData(item, index)}
              className={clsx(
                classes.labelRoot,
                // item.activeLink && classes.activeLabel
                classes.activeLabel
              )}
            >
              {productDetails.productType === BiTubeProduct.LightCycler
                ? item.name || BitubeProperties.NewOligo
                : productDetails.productType === BiTubeProduct.mirna
                  ? item.antisenceName || BitubeProperties.NewDuplex
                  : item.name || BitubeProperties.NewDuplex}
            </Link>
            {displayError(index)}
          </Grid>
          <Grid item sm={1}>
            <IconButton
              aria-label="delete"
              className={classes.delete}
              onClick={() => {
                handleDelete(item)
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </Grid>
        </Grid>
      )
    )

    return result
  }
  return (
    <>
      <Box mt={50}>
        <Grid
          container
          alignItems="flex-end"
          className={classes.header}
          justify="center"
        >
          <Grid item xs={12} sm={6}>
            <h3 className={classes.heading}>
              <span className={classes.heading}>
                {productDetails.productType === BiTubeProduct.LightCycler ? (
                  <FormattedMessage {...messages.CONF_MY_OLIGOS_SIDE_BAR} />
                ) : (
                  <FormattedMessage {...messages.CONF_MY_DUPLEXES_SIDE_BAR} />
                )}
              </span>
            </h3>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.view}>
            <Button
              onClick={handleViewAll}
              className={clsx(
                classes.viewAll,
                isIE
                  ? scrollBar
                    ? classes.viewAllScrollIE
                    : classes.buttonTextIe
                  : scrollBar
                    ? classes.viewAllScroll
                    : ''
              )}
              id="sidenav-view-all-button"
              data-testid="sidenav-view-all-button"
            >
              <FormattedMessage {...messages.CONF_VIEW_ALL_SIDE_BAR} />
            </Button>
          </Grid>
        </Grid>
        <TableContainer className={scrollBar ? classes.tableContainer : ''}>
          {renderData()}
        </TableContainer>
        <Divider variant="middle" className={classes.divider} />
        <Grid container spacing={1} alignItems="flex-end">
          <Grid item>
            <Button
              size="medium"
              className={classes.button}
              startIcon={<AddIcon />}
              onClick={addOligo}
              id="sidenav-add-button"
              data-testid="sidenav-add-button"
            >
              {productDetails.productType === BiTubeProduct.LightCycler ? (
                <FormattedMessage {...messages.CONF_ADD_OLIGO_SIDE_BAR} />
              ) : (
                <FormattedMessage {...messages.CONF_ADD_DUPLEX_SIDE_BAR} />
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <DeleteDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        onDelete={deleteOligoItem}
        type={delType}
      />
      <ViewAllDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        viewAllItems={sessionData}
        setActive={setActive}
        onDelete={deleteOligoItem}
        productName={productDetails.productType}
      />
    </>
  )
}

export default ProductsSummary
